import { render, staticRenderFns } from "./StartMaintenance.vue?vue&type=template&id=08831236&scoped=true&lang=pug&"
import script from "./StartMaintenance.vue?vue&type=script&lang=js&"
export * from "./StartMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./StartMaintenance.vue?vue&type=style&index=0&id=08831236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08831236",
  null
  
)

export default component.exports